import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { applyDocumentLocale, detectInitialLocale } from "./i18n";
import "./styles.css";

const root = document.getElementById("root");
if (!root) throw new Error("#root not found");

// Applied before the first paint. React would get there a tick later, and until
// then the document would claim to be English while already showing Chinese —
// which browsers use to pick fonts, line-breaking rules and hyphenation.
const { locale } = detectInitialLocale();
applyDocumentLocale(locale);

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
